<div class="notify-me-dialog">
  <div class="p-sm-3">
    <button class="mat-dialog__close-icon"><app-icon anchor="icon-close-xs" mat-dialog-close></app-icon></button>
    <header class="mb-3 mat-dialog__header">
      <h1 class="h3 mb-0">{{ data.prefix + '-titel' | fromDictionary }}</h1>
      <p class="mb-0">{{ data.prefix + '-tekst' | fromDictionary }}</p>
    </header>

    <mat-dialog-content class="mb-0 pb-0">
      <form [formGroup]="klaviyoEmailForm" (ngSubmit)="submit()">
        <div class="mt-3">
          <mat-form-field class="mat-form-field--white mb-2" [appearance]="'fill'" [color]="'accent'" [class.has--label]="true">
            <!--<mat-label>{{ 'formulier-veld-label-email' | fromDictionary }}</mat-label>-->

            <input
              matInput
              formControlName="email"
              [placeholder]="'formulier-veld-placeholder-email' | fromDictionary"
              autocomplete="email"
              type="text"
              />

            @if (klaviyoEmailForm.get('email')?.errors?.['email'] === true) {
              <mat-error>
                {{ 'formulier-email-error-bericht' | fromDictionary }}
              </mat-error>
            }
            @if (klaviyoEmailForm.get('email')?.errors?.['required'] === true) {
              <mat-error>
                {{ 'formulier-veld-verplicht-bericht' | fromDictionary }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <button class="button button--secondary mobile-w-100 mt-2" type="submit">
          <span>{{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte-knoptekst' | fromDictionary }}</span>
        </button>
      </form>
    </mat-dialog-content>
  </div>
</div>
